"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleOnIcon = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _toggleTheme = require("./toggleTheme");
const left = {
  large: 2,
  medium: 1
};
const ToggleOnIcon = (0, _styled.default)(_lodestarIcons.CheckIcon)`
    transition: opacity ${_ref => {
  let {
    themeMode
  } = _ref;
  return _toggleTheme.toggleTheme.motion.animation(themeMode);
}};
    opacity: ${_ref2 => {
  let {
    visible
  } = _ref2;
  return visible ? 1 : 0;
}};
    position: relative;
    left: ${_ref3 => {
  let {
    toggleSize
  } = _ref3;
  return left[toggleSize];
}}px;
`;
exports.ToggleOnIcon = ToggleOnIcon;
//# sourceMappingURL=ToggleOnIcon.js.map